import { render, staticRenderFns } from "./EmployeeAvailabilityIcon.vue?vue&type=template&id=63633afb"
import script from "./EmployeeAvailabilityIcon.vue?vue&type=script&lang=js"
export * from "./EmployeeAvailabilityIcon.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAvailabilityIcon.vue?vue&type=style&index=0&id=63633afb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports